import { SWAN_STYLE_KEY_MAP } from '@vp/swan';

export const HeroGallerySwanStyles = [
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.modalDialog,
  SWAN_STYLE_KEY_MAP.adaptiveCarousel,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.icon,
  SWAN_STYLE_KEY_MAP.progressiveImage,
  SWAN_STYLE_KEY_MAP.toggleSwitch,
  SWAN_STYLE_KEY_MAP.visible,
  SWAN_STYLE_KEY_MAP.utility,
  SWAN_STYLE_KEY_MAP.thumbnailsHero,
  SWAN_STYLE_KEY_MAP.zoomableImage,
  SWAN_STYLE_KEY_MAP.lightbox,
];
